import { useContext, useEffect } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { Select } from '@nv/basic-components'
import { ModalContext, useConfigurationContext } from '@nv/contexts'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './StrikeOffVoter.module.scss'

export const StrikeOffVoter = ({
  confirm,
  registeredVotingChannel = 'inPerson',
  votingDistricts = [],
  name,
  displayedVotingChannel,
}: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const { displayStrikeOffOnlyVotingChannels } = useConfigurationContext()

  let options = [{ value: 'inPerson', label: t('admin.electorsList.votedChannelOptions.inPerson') }]
  if (registeredVotingChannel === 'mail' && (KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin())) {
    options.push({ value: 'mail', label: t('admin.electorsList.votedChannelOptions.mail') })
  }
  if (displayStrikeOffOnlyVotingChannels?.length) {
    options = options.filter((o) => displayStrikeOffOnlyVotingChannels.includes(o.value))
  }
  if (displayedVotingChannel) {
    options = options.filter((o) => displayedVotingChannel === o.value)
  }

  const districtOptions = votingDistricts.map((district) => {
    return { value: district, label: district }
  })

  const formik = useFormik({
    initialValues: {
      votingChannel:
        (KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin() ? registeredVotingChannel : 'inPerson') ||
        options[0].value,
      votingDistrict: votingDistricts ? votingDistricts[0] : '',
    },
    validationSchema: Yup.object({ votingChannel: Yup.string().required(t('form.validations.votingMethodRequired')) }),
    onSubmit: (values) => confirm(values),
  })

  useEffect(() => {
    setHeaderLabel(t('buttons.strikeOff'))
    setBtns([
      { text: t('buttons.cancel'), variant: 'secondary', onClick: onClose, isCancel: true },
      { text: t('buttons.strikeOff'), onClick: formik.handleSubmit },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <div className={styles['title']}> {t('admin.electorsList.confirmStrikeOff', { name })}</div>
      <div className={styles['section']}>
        <Select
          label={t('admin.electorsList.votingChannel')}
          formik={formik}
          options={options}
          field='votingChannel'
          value={formik.values.votingChannel}
          isRequired={true}
        />
      </div>
      {/* <div className={styles['section']}>
        <Select
          label={t('admin.electorsList.votingDistrict')}
          formik={formik}
          options={districtOptions}
          field='votingDistrict'
          value={formik.values.votingDistrict}
          isRequired={true}
        />
      </div> */}
    </div>
  )
}
